import type * as api from '@gitbook/api-client';

type GetLocalizedValueOptions<T> = {
    /** The fallback value. */
    value: T;
    /** Per-language overrides. */
    localizedValue: Partial<Record<api.TranslationLanguage, T>> | undefined;
    /** The currently selected language. */
    selectedLanguage: api.TranslationLanguage | null;
    /** Whether we're in fallback mode. */
    isFallback: boolean;
};

/**
 * Computes the current value based on whether we're in fallback mode
 * or showing a language-specific override.
 */
export function getLocalizedValue<T>(options: GetLocalizedValueOptions<T>): T {
    const { value, localizedValue, selectedLanguage, isFallback } = options;

    if (isFallback || !selectedLanguage || !localizedValue) {
        return value;
    }

    return localizedValue[selectedLanguage] ?? value;
}
